<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :ok-disabled="true"
    :okText="this.$store.getters.language['common.okButton']"
    @setInnerFullscreen="setInnerFullscreen"
    :cancelText="language['common.closeButton']">
    <todo-task-form ref="realForm" @ok="submitCallback" @close="close" :setEdit="setEdit" v-if="initForm"
                  :disabled="disableSubmit" :innerFullscreen="innerFullscreen"></todo-task-form>
  </j-modal>
</template>

<script>

  import TodoTaskForm from './TodoTaskForm'

  export default {
    name: 'TodoTaskModal',
    components: {
      TodoTaskForm
    },
    data() {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false,
        innerFullscreen:false,
        setEdit:false,
        initForm:false,
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      setInnerFullscreen(val) {
        this.innerFullscreen = val
      },
      add() {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit(record) {
        this.setEdit = record.setEdit!==null&&record.setEdit!==''&&record.setEdit!==undefined?record.setEdit:false;
        this.innerFullscreen=false;
        this.initForm = true;
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close() {
        this.$emit('reSeach');
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        this.$refs.realForm.submitForm();
      },
      submitCallback() {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      }
    }
  }
</script>